import { Navigate, Outlet } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from './AuthProvider';
import type { Role } from '@/types/schemas';

export function ProtectedRoute({ allow }: { allow?: Role[] }) {
  const { user, role, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-ink text-cream">
        <Loader2 className="h-6 w-6 animate-spin text-gold-500" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (!role) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream px-6 text-center">
        <div className="max-w-md">
          <h1 className="font-serif text-2xl">Awaiting role assignment</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Your account exists but no role has been assigned. Please contact the
            owner to grant you access.
          </p>
        </div>
      </div>
    );
  }

  if (allow && !allow.includes(role)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream px-6 text-center">
        <div className="max-w-md">
          <h1 className="font-serif text-2xl">Access denied</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Your role ({role}) does not have permission to view this page.
          </p>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
